import React, { Component } from "react";
import { Growl } from "primereact/growl";
import Spinner from "../../../../Common/Spinner";
import "react-datepicker/dist/react-datepicker.css";
import { InputText } from "primereact/inputtext";
import "react-inputs-validation/lib/react-inputs-validation.min.css";
import axios from "axios";
import * as appConst from "../../../../Common/constants";

class SkuAddEdit extends Component {
  constructor(props) {
    super(props);

    var
      _id,
      _sku,
      _mode;
    if (this.props.pData.id == "NA") {
      _id = "NA";
      _sku = "";
      _mode = "add";
    } else {
      _id = this.props.pData.id;
      _sku = this.props.pData.sku;
      _mode = "edit";
    }

    this.state = {
      id: _id,
      sku: _sku,
      spinnerClass: "collapse",
      dataClass: "",
      mode: _mode
    };
  }

  render() {
    return (
      <div>
        <h5 align="center"> {this.getHeading()}</h5>
        <div className={this.state.spinnerClass}>
          <Spinner />
        </div>
        <div className={this.state.dataClass}>
          <div className="container-fluid">
            <div className="row p-1 border">
              <div className="col col-md-2">SKU</div>
              <div className="col col-md-3">
                <InputText
                  type="text"
                  value={this.state.sku}
                  onChange={e => this.setState({ sku: e.target.value })}
                  style={{ width: "300px" }}
                />
              </div>
            </div>
            <div className="row p-1 border">
              <button
                onClick={this.onSaveClick}
                className="btn btn-primary btn-md mr-2"
              >
                Save
              </button>
              <button
                onClick={this.onClearClick}
                className="btn btn-primary btn-md mr-2"
              >
                Clear
              </button>
              <button
                onClick={this.onCancelClick}
                className="btn btn-primary btn-md mr-2"
              >
                Cancel
              </button>
            </div>
            <Growl ref={el => (this.growl = el)} />
          </div>
        </div>
      </div>
    );
  }

  getHeading() {
    if (this.state.id == "NA" || this.state.id == "") {
      return "Add New SKU";
    } else {
      return "Edit SKU " + this.state.sku;
    }
  }

  onSaveClick = async e => {
    e.preventDefault();

    if (
      this.state.sku !== ""
    ) {
      const obj = {
        sku: this.state.sku,
        platform: "FK"
      };
      if (this.state.mode === "add") {
        axios
          .post(
            (process.env.NODE_ENV !== "development"
              ? appConst.API_URL_PROD
              : appConst.API_URL_DEV) +
            "/sku",
            obj
          )
          .then(
            res => {
              if (res.status === 200) {
                this.ClearData();
                this.growl.show({
                  severity: "success",
                  summary: "Success",
                  detail: "SKU Added !!!"
                });
              } else if (res.status === 204) {
                this.growl.show({
                  severity: "error",
                  summary: "Error !!",
                  detail: "SKU already exists !!"
                });
              }
            }
          );
      } else {
        axios
          .put(
            (process.env.NODE_ENV !== "development"
              ? appConst.API_URL_PROD
              : appConst.API_URL_DEV) +
            "/sku/" +
            this.props.pData.id,
            obj
          )
          .then(res => {
            this.growl.show({
              severity: "success",
              summary: "Success",
              detail: "SKU Updated !!!"
            });
            this.props.onClick("List", null);
          });
      }
    }
  };

  ClearData() {
    this.setState({ sku: "" });
  }

  onClearClick = e => {
    this.ClearData();
    this.growl.show({
      severity: "success",
      summary: "Success",
      detail: "Data Cleared !!!"
    });
  };

  onCancelClick = e => {
    this.props.onClick("List", null);
  };
}

export default SkuAddEdit;
